<template>
  <ContentSection>
    <Container>
      <h2
        v-if="data.title"
        class="mb-4 ml-8 text-md font-bold md:text-xl lg:text-2xl"
      >
        {{ data.title }}
      </h2>
      <div class="grid grid-cols-1 gap-x-10 xl:grid-cols-2">
        <div
          v-for="item in data.locations"
          :key="item.id"
          class="flex w-full flex-col max-xl:mt-5 first:max-xl:mt-0"
        >
          <div class="flex flex-col gap-2 bg-gray-10 p-8">
            <h2 class="font-bold">{{ item.title }}</h2>
            <p>{{ item.name }}</p>
            <a
              :href="`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(item.street + ', ' + item.place)}`"
              target="_blank"
            >
              <span class="mb-2 block">{{ item.street }}</span
              ><span class="block"> {{ item.place }}</span>
            </a>
            <a :href="`tel:${item.phone}`">{{ item.phone }}</a>
            <a class="font-bold underline" :href="`mailto:` + item.email">{{
              item.email
            }}</a>
          </div>
          <GoogleMap
            v-if="item.lat && item.lng"
            class="h-80 w-full"
            :api-key="config.public.GOOGLE_MAPS_KEY ?? ''"
            :center="{ lat: Number(item.lat), lng: Number(item.lng) }"
            :zoom="14"
          >
            <Marker
              :options="{
                position: { lat: Number(item.lat), lng: Number(item.lng) },
              }"
            />
          </GoogleMap>
        </div>
      </div>
    </Container>
  </ContentSection>
</template>

<script setup lang="ts">
import { GoogleMap, Marker } from 'vue3-google-map'
import Item from '~/components/shop/account/brand/Item.vue'
const config = useRuntimeConfig()
defineProps<{
  data: {
    title: string
    locations: {
      id: string
      email: string
      phone: string
      name: string
      title: string
      info_text: string
      place: string
      street: string
      lat: number
      lng: number
    }[]
  }
}>()
</script>
